import { render, staticRenderFns } from "./TheBaReSuDeButtons.vue?vue&type=template&id=912ee22a&scoped=true&"
import script from "./TheBaReSuDeButtons.vue?vue&type=script&lang=js&"
export * from "./TheBaReSuDeButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912ee22a",
  null
  
)

export default component.exports